module.exports = __webpack_public_path__ + "media/images/skin_cancer_index-749e9bd60731dba22e27330edcbf5e26.png";